// @ts-nocheck
import { addToChainAfter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";
import { Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = GetProductCollectionRealTimeInventoryApiV2Parameter &
    HasOnSuccess<RealTimeInventoryModel> &
    HasOnError<unknown>;

type Props = {
    apiParameter: GetProductCollectionRealTimeInventoryApiV2Parameter;
    apiResult: RealTimeInventoryModel;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;
export const filterVariantParent: HandlerType = props => {
    const { apiParameter } = props;
    const state = props.getState();
    const filteredProductIds = apiParameter.productIds.filter(productId => {
        const product = getProductState(state, productId);
        return !product?.value?.isVariantParent === true;
    });

    apiParameter.productIds = filteredProductIds;
};
addToChainAfter(chain, PopulateApiParameter, filterVariantParent);
